<template>
  <div class="cruise-pms-app app-shell" :class="{ 'report-focus': reportFocus }">
    <TopBar v-show="!reportFocus" />
    <div class="app-shell__body">
      <SideBar />
      <section class="app-shell__workspace">
        <TagsView />
        <main class="app-main">
          <RouterView />
        </main>
      </section>
    </div>
    <MobileBottomNav v-show="!reportFocus" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { RouterView, useRoute } from "vue-router";
import MobileBottomNav from "./components/MobileBottomNav.vue";
import SideBar from "./components/SideBar.vue";
import TagsView from "./components/TagsView.vue";
import TopBar from "./components/TopBar.vue";
import { useSystemContextStore } from "@/stores/system-context";
import { useAuthStore } from "@/stores/auth";
import { useMobileViewportInsets } from "@/composables/useMobileViewportInsets";
import { useMobileLayout } from "@/composables/useMobileLayout";

useMobileViewportInsets();
const { isMobile } = useMobileLayout();
const route = useRoute();
const reportFocus = computed(() => isMobile.value && route.name === "personal-report-editor");
const systemContext = useSystemContextStore();
const auth = useAuthStore();
onMounted(async () => {
  await auth.load();
  await systemContext.load();
});
</script>
